import React, { useState, useEffect } from 'react';

import { useTheme } from 'styled-components';

import { FaFileExcel } from 'react-icons/fa';
import { FaFilePdf } from 'react-icons/fa';
import { IoMdArrowDropup, IoMdArrowDropdown } from 'react-icons/io';
import { FaTag } from 'react-icons/fa';
import { FaRegClock } from 'react-icons/fa';

import api from '~/services/api';

import { exportCsv } from '~/helpers/csv';
import { exportPdf } from '~/helpers/pdf';

import {
  Scroll,
  Container,
  Header,
  Progress,
  Loading,
  Grid,
  GridLine,
  GridHeadItem,
  GridItem,
} from '~/components';

import { GraphArea, LoadArea, Tags, ToogleInfo } from './styles';

import Grafico from './Grafico';

import RelatorioVendaHorario from '~/@types/relatoriovendahorario';
import RelatorioVendaHorarioHora from '~/@types/relatoriovendahorariohora';

const VendasPorHorario: React.FC = () => {
  const { colors } = useTheme();

  const [inLoad, setInLoad] = useState(false);

  // VENDAS HORARIO
  const [vendashorario, setVendashorario] = useState<RelatorioVendaHorario[]>(
    [],
  );
  const [vendasHorarioVisibilidade, setGraficoVisibilidade] = useState(true);
  const [moduloGrafico, setModuloGrafico] = useState('hoje');

  // MODULO (VENDAS HORÁRIO)
  const filtrarHorariosPorModulo = (
    pModuloGrafico: string,
    pGrafico: RelatorioVendaHorario[],
  ) => {
    const horarios: RelatorioVendaHorarioHora[] = [];

    let c;
    for (c in pGrafico) {
      const relatorio = pGrafico[c];
      if (relatorio.nome === pModuloGrafico) {
        let d;
        for (d in relatorio.horarios) {
          const horario = relatorio.horarios[d];
          horarios.push(horario);
        }
      }
    }

    return horarios;
  };

  const gerarRelatorioGraficoCSV = () => {
    let data: string[] = [];

    data.push('HORA;PEDIDOS;PRODUTOS;FRETE;DESCONTO;TICKETMEDIO;TOTAL');

    const horarios = filtrarHorariosPorModulo(moduloGrafico, vendashorario);

    let d;
    for (d in horarios) {
      const horario = horarios[d];

      data.push(
        `${horario.hora};${horario.pedidos};${horario.produtos};${horario.frete};${horario.desconto};${horario.ticketmedio};${horario.total}`,
      );
    }

    const csv = data.join('\n');

    exportCsv(csv, `VENDAS HORARIO - ${moduloGrafico.toUpperCase()}`);
  };

  const gerarRelatoriosGraficoPDF = () => {
    const cabecalho = [
      'ANO',
      'MES',
      'DIA',
      'PEDIDOS',
      'PRODUTOS',
      'FRETE',
      'DESCONTO',
      'TICKETMEDIO',
      'TOTAL',
    ];

    const data: string[][] = [];

    const horarios = filtrarHorariosPorModulo(moduloGrafico, vendashorario);

    let d;
    for (d in horarios) {
      const horario = horarios[d];

      const linha: string[] = [];

      linha.push(`${horario.hora}`);
      linha.push(`${horario.pedidos}`);
      linha.push(`${horario.produtos}`);
      linha.push(`${horario.frete}`);
      linha.push(`${horario.desconto}`);
      linha.push(`${horario.ticketmedio}`);
      linha.push(`${horario.total}`);

      data.push(linha);
    }

    exportPdf(
      cabecalho,
      data,
      `VENDAS HORARIO - ${moduloGrafico.toUpperCase()}`,
    );
  };

  const exibicaoTotalPedidos = (pTotalPedidos: number) => {
    if (!pTotalPedidos) return 'Nenhum pedido';
    if (pTotalPedidos === 1) {
      return 'Um pedido';
    }
    return `${pTotalPedidos} pedidos`;
  };

  useEffect(() => {
    const fetchVendasPorHorario = async () => {
      try {
        setInLoad(true);
        setVendashorario([]);

        const ano = new Date().getFullYear();
        const modulo = 'vendas_por_horario';

        const response = await api.get(
          `relatorios?ano=${ano}&modulo=${modulo}`,
        );

        const { data } = response;

        if (data && Array.isArray(data) && data.length) {
          setVendashorario(data);
        }

        setInLoad(false);
      } catch (e) {
        setInLoad(false);
      }
    };

    fetchVendasPorHorario();
  }, []);

  return (
    <>
      {inLoad ? <Progress /> : null}

      <Scroll>
        <Container>
          <Header
            title="Vendas por horário"
            subtitle="Confira as métricas de vendas distribuídas por horário"
            icon={
              <>
                <FaRegClock size={32} color={colors.IC1} />
              </>
            }
          />

          {inLoad ? (
            <LoadArea>
              <Loading color={colors.IC1} size={42} />
            </LoadArea>
          ) : null}

          {vendashorario.length ? (
            <GraphArea>
              <header>
                <i>
                  <FaRegClock size={26} color={colors.IC1} />
                </i>
                <p>
                  <h1>Vendas por horário</h1>
                  <h2>
                    Confira as métricas de vendas distribuídas por horário
                  </h2>
                </p>

                <div>
                  <button
                    className="excel"
                    onClick={gerarRelatorioGraficoCSV}
                    title="Exportar para Excel"
                  >
                    <FaFileExcel size={22} color={colors.IC2} />
                    <div>
                      <h3>EXPORTAR</h3>
                      <h2>EXCEL</h2>
                    </div>
                  </button>
                  <button
                    className="pdf"
                    onClick={gerarRelatoriosGraficoPDF}
                    title="Exportar para PDF"
                  >
                    <FaFilePdf size={22} color={colors.IC2} />
                    <div>
                      <h3>EXPORTAR</h3>
                      <h2>PDF</h2>
                    </div>
                  </button>
                </div>
              </header>

              <Tags>
                <div>
                  <button
                    className={moduloGrafico === 'hoje' ? 'active' : ''}
                    onClick={() => setModuloGrafico('hoje')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Hoje</span>
                  </button>
                  <button
                    className={
                      moduloGrafico === 'ultimos-7-dias' ? 'active' : ''
                    }
                    onClick={() => setModuloGrafico('ultimos-7-dias')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Últimos 7 Dias</span>
                  </button>
                  <button
                    className={moduloGrafico === 'mes-atual' ? 'active' : ''}
                    onClick={() => setModuloGrafico('mes-atual')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Mês Atual</span>
                  </button>
                  <button
                    className={moduloGrafico === 'mes-passado' ? 'active' : ''}
                    onClick={() => setModuloGrafico('mes-passado')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Mês Passado</span>
                  </button>
                  <button
                    className={moduloGrafico === 'ano-atual' ? 'active' : ''}
                    onClick={() => setModuloGrafico('ano-atual')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Ano Atual</span>
                  </button>
                  <button
                    className={moduloGrafico === 'ano-passado' ? 'active' : ''}
                    onClick={() => setModuloGrafico('ano-passado')}
                  >
                    <i>
                      <FaTag size={18} color={colors.IC1} />
                    </i>
                    <span>Ano Passado</span>
                  </button>
                </div>
              </Tags>

              <main>
                <div>
                  <Grafico
                    horarios={filtrarHorariosPorModulo(
                      moduloGrafico,
                      vendashorario,
                    )}
                  />
                </div>
              </main>

              <footer>
                {vendasHorarioVisibilidade ? (
                  <Grid>
                    <GridLine>
                      <GridHeadItem title="Horário" />
                      <GridHeadItem title="Pedidos" width={150} />
                      <GridHeadItem title="Produtos" width={150} />
                      <GridHeadItem title="Frete" width={150} />
                      <GridHeadItem title="Desconto" width={150} />
                      <GridHeadItem title="Ticket Médio" width={150} />
                      <GridHeadItem title="Total" width={150} />
                    </GridLine>

                    {filtrarHorariosPorModulo(moduloGrafico, vendashorario).map(
                      horario => (
                        <GridLine key={horario.hora}>
                          <GridItem>{horario.hora}</GridItem>
                          <GridItem width={150}>
                            {exibicaoTotalPedidos(horario.pedidos)}
                          </GridItem>
                          <GridItem width={150}>
                            {horario.produtos.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </GridItem>
                          <GridItem width={150}>
                            {horario.frete.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </GridItem>
                          <GridItem width={150}>
                            {horario.desconto.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </GridItem>
                          <GridItem width={150}>
                            {horario.ticketmedio.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </GridItem>
                          <GridItem width={150}>
                            {horario.total.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL',
                            })}
                          </GridItem>
                        </GridLine>
                      ),
                    )}
                  </Grid>
                ) : null}
                <ToogleInfo
                  onClick={() =>
                    setGraficoVisibilidade(!vendasHorarioVisibilidade)
                  }
                >
                  {vendasHorarioVisibilidade ? (
                    <IoMdArrowDropup size={32} color={colors.IC1} />
                  ) : (
                    <IoMdArrowDropdown size={32} color={colors.IC1} />
                  )}
                </ToogleInfo>
              </footer>
            </GraphArea>
          ) : null}
        </Container>
      </Scroll>
    </>
  );
};

export default VendasPorHorario;
